import { render, staticRenderFns } from "./managed.vue?vue&type=template&id=39bb5119&"
import script from "./managed.vue?vue&type=script&lang=js&"
export * from "./managed.vue?vue&type=script&lang=js&"
import style0 from "./managed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports